<template>
    <section>
        <button @click="cancelFunc">Cancelar</button>
        <button class="okClass" @click="okFunc">Confirmar</button>
    </section>
</template>

<script>
export default {
    name:"RTAModalButtons",
    props:{
        okFunc:{type: Function, required: false, default: () => {}},
        cancelFunc:{type: Function, required: false, default: () => {}}
    },
}
</script>

<style scoped>
section{
    display: flex;
    align-items: center;
    column-gap: 0.8rem;
    justify-content: flex-end;
    margin-top: 0.5rem;
    padding-top: 0.3rem;
    border-top: 1px solid rgb(196, 196, 196);
}

section button{
    padding: 0.5rem;
    font-weight: 500;
    color: white;
    background-color: gray;
    border: none;
    border-radius: 0.2rem;
}

.okClass{
    background-color: #ff5f00;
}
</style>